import { render, staticRenderFns } from "./LiveWebinar.vue?vue&type=template&id=5b075524"
import script from "./LiveWebinar.vue?vue&type=script&lang=js"
export * from "./LiveWebinar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports